import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RelatieSpecificaComponent } from './relatie-specifica.component';
import { AddRelatieSpecificaComponent } from './add-relatie-specifica/add-relatie-specifica.component';
import { EditRelatieSpecificaComponent } from './edit-relatie-specifica/edit-relatie-specifica.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
    declarations: [
        RelatieSpecificaComponent,
        AddRelatieSpecificaComponent,
        EditRelatieSpecificaComponent
    ],
    imports: [
        CommonModule, MaterialModule, FormsModule, ReactiveFormsModule
    ],
    exports: [RelatieSpecificaComponent],
})
export class RelatieSpecificaModule { }
